import React, { useState, useEffect } from 'react';
import { Collapse, Spin } from 'antd';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';

const { Panel } = Collapse;

const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await api.get('/faqs');
      if (response.data.success) {
        setFaqs(response.data.data);
        // Extract unique categories
        const uniqueCategories = [...new Set(response.data.data.map(faq => faq.category))];
        setCategories(uniqueCategories);
      }
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredFaqs = activeCategory === 'all' 
    ? faqs 
    : faqs.filter(faq => faq.category === activeCategory);

  return (
    <div className="home-page">
      <Helmet>
        <title>FAQs - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
      
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5">
                <div className="divider divider-simple text-center">
                  <h3>FAQs</h3>
                </div>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-3">
              <div className="card">
                <div className="card-header">
                  <h5>Categories</h5>
                </div>
                <div className="card-body">
                  <ul className="list-group">
                    <li 
                      className={`list-group-item ${activeCategory === 'all' ? 'active' : ''}`}
                      onClick={() => setActiveCategory('all')}
                      style={{ cursor: 'pointer' }}
                    >
                      All Categories
                    </li>
                    {categories.map(category => (
                      <li 
                        key={category}
                        className={`list-group-item ${activeCategory === category ? 'active' : ''}`}
                        onClick={() => setActiveCategory(category)}
                        style={{ cursor: 'pointer' }}
                      >
                        {category}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="col-lg-9">
              {loading ? (
                <div className="text-center">
                  <Spin size="large" />
                </div>
              ) : (
                <Collapse accordion>
                  {filteredFaqs.map(faq => (
                    <Panel header={faq.question} key={faq.id}>
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </Panel>
                  ))}
                </Collapse>
              )}
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Faq;